import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/card-2.jpg'


const _hoisted_1 = {
  class: "tab-content",
  id: "myTab6Content"
}
const _hoisted_2 = {
  class: "tab-pane fade",
  id: "code6-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "code6-tab",
  tabindex: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[3] || (_cache[3] = _createElementVNode("ul", {
      class: "nav nav-tabs mb-4 bg-white",
      id: "myTab6",
      role: "tablist"
    }, [
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link active",
          id: "preview6-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#preview6-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "preview6-tab-pane",
          "aria-selected": "true"
        }, " Preview ")
      ]),
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link",
          id: "code6-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#code6-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "code6-tab-pane",
          "aria-selected": "false"
        }, " Code ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "tab-pane fade show active",
        id: "preview6-tab-pane",
        role: "tabpanel",
        "aria-labelledby": "preview6-tab",
        tabindex: "0"
      }, [
        _createElementVNode("div", { class: "card text-bg-dark border-0 rounded-3" }, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "card-img",
            alt: "card"
          }),
          _createElementVNode("div", { class: "position-absolute top-0 p-3" }, [
            _createElementVNode("span", { class: "badge bg-primary rounded-1 text-dark py-2 px-3 me-1 fs-13 fw-medium" }, "Primary"),
            _createElementVNode("span", { class: "badge bg-warning rounded-1 text-dark py-2 px-3 me-1 fs-13 fw-medium" }, "Warning"),
            _createElementVNode("span", { class: "badge bg-success rounded-1 text-dark py-2 px-3 me-1 fs-13 fw-medium" }, "Success")
          ]),
          _createElementVNode("div", {
            class: "card-img-overlay",
            style: {"top":"auto","bottom":"0"}
          }, [
            _createElementVNode("h5", { class: "card-title fs-18 fw-semibold" }, "Card title"),
            _createElementVNode("p", { class: "card-text" }, " This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer. "),
            _createElementVNode("p", { class: "card-text" }, [
              _createElementVNode("small", null, "Last updated 3 mins ago")
            ])
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0 mt-5",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
        }, " Copy "),
        _cache[1] || (_cache[1] = _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
          _createTextVNode(""),
          _createElementVNode("code", {
            class: "language-markup",
            id: "codeCopy"
          }, "\n<div class=\"card text-bg-dark border-0 rounded-3\">\n<img src=\"@/assets/images/card-2.jpg\" class=\"card-img\" alt=\"card\">\n<div class=\"position-absolute top-0 p-3\">\n<span class=\"badge bg-primary rounded-1 text-dark py-2 px-3 fs-13 fw-medium\">Primary</span>\n<span class=\"badge bg-warning rounded-1 text-dark py-2 px-3 fs-13 fw-medium\">Warning</span>\n<span class=\"badge bg-success rounded-1 text-dark py-2 px-3 fs-13 fw-medium\">Success</span>\n</div>\n<div class=\"card-img-overlay\" style=\"top: auto; bottom: 0;\">\n<h5 class=\"card-title\">Card title</h5>\n<p class=\"card-text\">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>\n<p class=\"card-text\"><small>Last updated 3 mins ago</small></p>\n</div>\n</div>\n"),
          _createTextVNode("\n")
        ], -1))
      ])
    ])
  ], 64))
}